import React from "react";
import styled from "styled-components";
import { Fieldset } from "react95";

import StandardSearch from "./StandardSearch";
import AdvancedSearch from "./AdvancedSearch";

const Container = styled.div`
    display: flex;

    @media (max-width: 768px) {
        flex-wrap: wrap;
    }
`;

const FormContainer = () => {
    return (
        <Fieldset style={{ marginTop: 20 }} label="Search Fields">
            <Container>
                <StandardSearch />
                <AdvancedSearch />
            </Container>
        </Fieldset>
    );
};

export default FormContainer;
